import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import {
	CompanyDocumentsResponse,
	GetManagerDetailsResponse,
	GetUserAssignmentResponse,
	UploadDocumentsResponse,
} from '../models/companyDocuments';

export const onUploadDocuments = async (data: FormData) => {
	try {
		const response = await axios.post<JsonResponse<UploadDocumentsResponse>>('dashboard/upload-legal-documents', data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data.data;
	} catch (error: any) {
		throw error;
	}
};

export const onUpdateDocuments = async (data: FormData) => {
	try {
		const response = await axios.post<JsonResponse<UploadDocumentsResponse>>('dashboard/update-legal-documents', data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data.data;
	} catch (error: any) {
		throw error;
	}
};

export const onGetDocuments = async () => {
	try {
		const response = await axios.get<JsonResponse<CompanyDocumentsResponse>>('dashboard/get-legal-documents');
		return response.data.data;
	} catch (error: any) {
		throw error;
	}
};

export const onGetUserAssignmentDocument = async () => {
	try {
		const response = await axios.get<JsonResponse<GetUserAssignmentResponse>>('dashboard/get-document-forms');
		return response.data.data;
	} catch (error: any) {
		throw error;
	}
};

export const onGetMangerDetails = async () => {
	try {
		const response = await axios.get<JsonResponse<GetManagerDetailsResponse>>('dashboard/get-manager-details');
		return response.data.data;
	} catch (error: any) {
		throw error;
	}
};

export const onSubmitMangerDetails = async (authorized_signatory_name: string) => {
	try {
		const response = await axios.put('dashboard/update-manager-details', { authorized_signatory_name });
		return response.data.data;
	} catch (error: any) {
		throw error;
	}
};
